import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  createWebSetting,
  getWebSetting,
  editWebSetting,
  publishWebSetting,
} from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import { UserLang } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";
import { NecStore } from "../../store/necStore";

const WebSetting = (props) => {
  const initState = {
    numberofMenuItem: "",
    thumbnailAnimation: "",
    loadingSpinner: "",
    deepLink: "",
    cookiePolicy: false,
    shading: true,
    imageBorder: true,
    float: "none",
    thumbnailDescription: "IMG",
  };

  const [colorSchema, setColor] = useState(initState);
  const [colorCount, setColorCount] = useState("");
  const [colorStatus, setColorStatus] = useState(0);
  const [loading, setLoading] = useState(false);
  const lan = UserLang.useState((s) => s.lan);
  const role = NecStore.useState((s) => s.setting);

  const menuPic = [
    {
      value: "Hour Glass",
      label: "Hour Glass",
    },
    {
      value: "Circular",
      label: "Circular",
    },
    {
      value: "Grid Line",
      label: "Grid Line",
    },
    {
      value: "Ellipsis",
      label: "Ellipsis",
    },
    {
      value: "Grid",
      label: "Grid",
    },
    {
      value: "Ripple",
      label: "Ripple",
    },
  ];
  /* eslint-disable no-unused-vars */
  const [allIcon, setIcon] = useState(menuPic);

  const handleChange = (evt) => {
    const value = evt.target.value;
    setColor({
      ...colorSchema,
      [evt.target.name]: value,
    });
  };

  const onChangeItemed = (value, evt) => {
    setColor({
      ...colorSchema,
      [evt.name]: value.value,
    });
  };
  const updateVisiblity = (event) => {
    setColor({
      ...colorSchema,
      [event.target.name]: event.target.checked,
    });
  };

  useEffect(() => {
    const colorDetail = async () => {
      setLoading(true);
      /* eslint-disable no-unused-vars */
      const result = await getWebSetting().then(
        (result) => {
          setColor(result.data);
          setLoading(false);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setColorCount(obj.message);
          setColorStatus(obj.status);
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    colorDetail();
  }, []);

  const colorSave = async (event) => {
    setLoading(true);
    event.preventDefault();

    if (colorStatus === 404 || colorCount === "No Web Setting Schema Exists") {
      /* eslint-disable no-unused-vars */
      const result = await createWebSetting(colorSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
      /* eslint-disable no-unused-vars */
    } else {
      const result = await editWebSetting(colorSchema).then(
        (result) => {
          toastr.success("Successfully Saved", "Success");
          setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          setLoading(false);
        }
      );
    }
  };

  const publish = async (event) => {
    // setDisable(true);
    // setLoading(true);
    event.preventDefault();
    if (role.production === true) {
      /* eslint-disable no-unused-vars */
      const result = await publishWebSetting().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
          // setLoading(false);
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          // setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Web Setting Schema
                  </h3>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <form onSubmit={colorSave}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Enter the number of menus in the web platform"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Number of Menu Items&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Enter the number of menus in the web platform"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="number"
                            name="numberofMenuItem"
                            className="form-control inside-form"
                            placeholder="Number of Menu Items"
                            defaultValue={colorSchema.numberofMenuItem}
                            onChange={handleChange}
                            autoComplete="off"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Enter the general URL used for DeepLink action"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;DeepLink Url&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Enter the general URL used for DeepLink action"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <input
                            type="text"
                            name="deepLink"
                            className="form-control inside-form"
                            placeholder="Deep Link URL..."
                            defaultValue={colorSchema.deepLink}
                            onChange={handleChange}
                            autoComplete="off"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"shading"}
                              id={"shading"}
                              defaultChecked={colorSchema.shading}
                              onClick={(event) => updateVisiblity(event)}
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "float-right custom-control-label not-bold"
                                  : "float-left custom-control-label not-bold"
                              }
                              htmlFor={"shading"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              Details Page Shading&nbsp;
                              <ToolTip
                                info={
                                  "Enable shading effect for the details page"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"cookiePolicy"}
                              id={"cookiePolicy"}
                              defaultChecked={colorSchema.cookiePolicy}
                              onClick={(event) => updateVisiblity(event)}
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "float-right custom-control-label not-bold"
                                  : "float-left custom-control-label not-bold"
                              }
                              htmlFor={"cookiePolicy"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              Cookie Policy&nbsp;
                              <ToolTip
                                info={"Enable for cookies for web platform"}
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            </label>
                          </div>
                        </div>
                      </div>

                      {!(lan === "rtl") && (
                        <div className="col-sm-6">
                          <div className="row">
                            <div
                              className="col-sm-12"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Select default loading animation for the platform"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Loading Spinner&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Select default loading animation for the platform"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="loadingSpinner"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allIcon}
                                onChange={(value, event) =>
                                  onChangeItemed(value, event)
                                }
                              ></Select>

                              <div
                                className="row"
                                style={{
                                  marginTop: "100px",
                                  backgroundColor: "#f2f2f2",
                                  marginLeft: "px",
                                }}
                              >
                                <div
                                  className="col-md-6"
                                  style={{
                                    marginTop: "20px",
                                    marginLeft: "2px",
                                  }}
                                >
                                  <span>{colorSchema.loadingSpinner}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              name={"imageBorder"}
                              id={"imageBorder"}
                              defaultChecked={colorSchema.imageBorder}
                              onClick={(event) => updateVisiblity(event)}
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            />
                            <label
                              className={
                                lan === "rtl"
                                  ? "float-right custom-control-label not-bold"
                                  : "float-left custom-control-label not-bold"
                              }
                              htmlFor={"imageBorder"}
                              onClick={(e) => e.stopPropagation()}
                            >
                              Image & Thumbnail Border&nbsp;
                              <ToolTip
                                info={
                                  "Enable for border effect to the platform"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      {lan === "rtl" && (
                        <div className="col-sm-6">
                          <div className="row">
                            <div
                              className="col-sm-12"
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                            >
                              <label
                                className={
                                  lan === "rtl" ? "float-right" : "float-left"
                                }
                              >
                                {lan === "rtl" && (
                                  <ToolTip
                                    info={
                                      "Select default loading animation for the platform"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                                &nbsp;Loading Spinner&nbsp;
                                {!(lan === "rtl") && (
                                  <ToolTip
                                    info={
                                      "Select default loading animation for the platform"
                                    }
                                    place={lan === "rtl" ? "left" : "right"}
                                  />
                                )}
                              </label>
                              <Select
                                name="loadingSpinner"
                                className={
                                  lan === "rtl"
                                    ? "form-control inside-select float-right"
                                    : "form-control inside-select float-left"
                                }
                                options={allIcon}
                                onChange={(value, event) =>
                                  onChangeItemed(value, event)
                                }
                              ></Select>

                              <div
                                className="row"
                                style={{
                                  marginTop: "100px",
                                  backgroundColor: "#f2f2f2",
                                  marginLeft: "px",
                                }}
                              >
                                <div
                                  className="col-md-6"
                                  style={{
                                    marginTop: "20px",
                                    marginLeft: "2px",
                                  }}
                                >
                                  <span>{colorSchema.loadingSpinner}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="row mb-2 mt-2"></div>
                      <div className="row mb-2 mt-2"></div>
                      <div className="row mb-2 mt-2"></div>
                      {lan === "rtl" && <div className="col-sm-6"></div>}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Define the aligment for the menu in the web platform"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Menu Float&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Define the aligment for the menu in the web platform"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <select
                            name="float"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            className="form-control inside-form"
                            value={colorSchema.float}
                            onChange={handleChange}
                            required
                          >
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="none"
                            >
                              Default
                            </option>
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="left"
                            >
                              Left
                            </option>
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="right"
                            >
                              Right
                            </option>
                          </select>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label
                            className={
                              lan === "rtl" ? "float-right" : "float-left"
                            }
                          >
                            {lan === "rtl" && (
                              <ToolTip
                                info={
                                  "Defines how you want title & description on image thumbnail to display"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                            &nbsp;Thumbnail Title & Description&nbsp;
                            {!(lan === "rtl") && (
                              <ToolTip
                                info={
                                  "Defines how you want title & description on image thumbnail to display"
                                }
                                place={lan === "rtl" ? "left" : "right"}
                              />
                            )}
                          </label>
                          <select
                            name="thumbnailDescription"
                            dir={lan === "rtl" ? "rtl" : "ltr"}
                            className="form-control inside-form"
                            value={colorSchema.thumbnailDescription}
                            onChange={handleChange}
                            required
                          >
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="IMG"
                            >
                              On Image
                            </option>
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="BIMWR"
                            >
                              Below the Image With Rating
                            </option>
                            <option
                              dir={lan === "rtl" ? "rtl" : "ltr"}
                              value="BIM"
                            >
                              Below the Image Without Rating{" "}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row mb-2 mt-2"></div>

                    <div className="row">
                      <div className="col-12">
                        <div
                          className={
                            lan === "rtl"
                              ? "float-left btn-group btn-group-md"
                              : "float-right btn-group btn-group-md"
                          }
                          role="group"
                        >
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ width: "100px", marginRight: "6px" }}
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            onClick={publish}
                            className="btn btn-success"
                            style={{ width: "100px", marginRight: "6px" }}
                            disabled={!role.production === true ? true : false}
                            hidden={!role.production === true ? true : false}
                          >
                            Publish
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
};

export default WebSetting;
